import { DatePipe } from '@angular/common';
import { Component, OnInit,ChangeDetectionStrategy, AfterViewChecked, Input } from '@angular/core';
import {   FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { PaginationInstance } from 'ngx-pagination';
import { AuthService, FundsPortalService, LocalStorageService, Options } from 'src/app/core/core.module';

@Component({
  selector: 'app-upload-history',
  templateUrl: './upload-history.component.html',
  styleUrls: ['./upload-history.component.less'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class UploadHistoryComponent implements OnInit {
  public searchFormGroup!: FormGroup; 

  public historyList: Array<any> = [];
  public searchOptions: Array<Options> = [];
  public pageCount: number = 0;
  public pageSize: number = 10;
  public currentPage: number = 1;
  public selectedPage: number = 1;
  public totalItems: number = 1;

  @Input('data') meals: string[] = [];

  public config: PaginationInstance = {
      id: 'custom',
      itemsPerPage: this.pageSize,
      currentPage: 1,
      totalItems: this.totalItems
  };


  constructor(
    public datePipe: DatePipe,
    public fundsPortalService: FundsPortalService,
    public localStorageService: LocalStorageService,
    public authService: AuthService,
     public router: Router
    
  ) { }

  ngOnInit(): void {
    this.authService.refreshToken();
    this.searchOptions.push(new Options(
      '10 / page',
      '10',
      true
    ));
    this.searchOptions.push(new Options(
      '20 / page',
      '20',
      false
    ));

    this.searchOptions.push(new Options(
      '30 / page',
      '30',
      false
    ));

    this.searchOptions.push(new Options(
      '40 / page',
      '40',
      false
    ));

    this.searchOptions.push(new Options(
      '50 / page',
      '50',
      false
    ));
    this.initializeFormGroup();
    this.getDocuments();
    this.onChangeValueDate();
  }

  //#region Form Group Events
  initializeFormGroup(): void {
    this.searchFormGroup = new FormGroup({
      searchField: new FormControl('', [Validators.required]),
      searchDate: new FormControl('', [Validators.required]),
      pageSize: new FormControl('10', [Validators.required])
    });
  }
  getPage(page: number) {
    this.config.currentPage = page;
    this.getDocuments();
  }


  onPageBoundsCorrection(number: number) {
    this.config.currentPage = number;
  }

  setPageSize(){
    this.config.itemsPerPage = this.searchFormGroup.get('pageSize')?.value;
    this.config.currentPage = 1;
    this.getDocuments();
  }

  scrollTop() {
    window.scrollTo(0, 0)
  }

  onChangeValueDate(): void {
    this.authService.refreshToken();
    const control = this.searchFormGroup.get('searchDate');
    control?.valueChanges.subscribe(value => {
      if (value) {
        this.getDocuments();
      } else if(!value.valid  && control.touched){

        // this.isErrorEmail =true;      
      }
    });
  }

  getDocuments(){
    this.authService.refreshToken();
    var body = {};
    // var body = {
    //   page_number: this.config.currentPage,
    //   page_size: this.searchFormGroup.get('pageSize')?.value
    // }
    if(this.searchFormGroup.get('searchDate')?.value){
      body = {
        page_number: this.config.currentPage,
        page_size: this.searchFormGroup.get('pageSize')?.value,
        wild_search : this.searchFormGroup.get('searchField')?.value,
        start_date: this.datePipe.transform(this.searchFormGroup.get('searchDate')?.value[0], 'MM/dd/yyyy'),
        end_date: this.datePipe.transform(this.searchFormGroup.get('searchDate')?.value[1], 'MM/dd/yyyy')
      }
    }
    else{
      body = {
        page_number: this.config.currentPage,
        page_size: this.searchFormGroup.get('pageSize')?.value,
        wild_search : this.searchFormGroup.get('searchField')?.value
      }
    }
    return new Promise((resolve, reject) => {
      this.fundsPortalService.getDocuments(body).subscribe({
          next: (data:any) =>{
          resolve(data);
          this.historyList = data['response_data']['data'];
          this.pageCount = data['response_data']['total_pages'];
          this.config.totalItems = data['response_data']['total_records'];
          this.scrollTop();
        },
        error: error =>{
          return;
          }
      })
    });
  }

  searchDocuments(page: number){
    this.authService.refreshToken();
    this.selectedPage = page;
    this.scrollTop();
    var body = {}
    if(this.searchFormGroup.get('searchDate')?.value){
      body = {
        page_number: page,
        page_size: this.searchFormGroup.get('pageSize')?.value,
        wild_search : this.searchFormGroup.get('searchField')?.value,
        start_date: this.datePipe.transform(this.searchFormGroup.get('searchDate')?.value[0], 'MM/dd/yyyy'),
        end_date: this.datePipe.transform(this.searchFormGroup.get('searchDate')?.value[1], 'MM/dd/yyyy')
      }
    }
    else{
      body = {
        page_number: page,
        page_size: this.searchFormGroup.get('pageSize')?.value,
        wild_search : this.searchFormGroup.get('searchField')?.value
      }
    }
    return new Promise((resolve, reject) => {
      this.fundsPortalService.getDocuments(body).subscribe({
        next: (data:any) =>{
          resolve(data);
          this.historyList = data['response_data']['data'];
          this.pageCount = data['response_data']['total_pages'];
          this.config.totalItems = data['response_data']['total_records'];
          this.currentPage = page;
        },
        error: error =>{
          return;
          }
      })
    });
  }
}
